var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFont(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 12,
    rx: 1.504,
    fill: "#AD0C24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.797 3.45l1.001 3.838.935-3.838h1.056l.934 3.838 1.002-3.838h.975l-1.436 5.1h-1.082l-.921-3.678-.922 3.678h-1.082l-1.442-5.1h.982zM10.432 3.45v.91H9.197c-.32 0-.554.025-.701.076a.722.722 0 00-.367.299 1.041 1.041 0 00-.14.305 4.21 4.21 0 00-.06.52h2.503v.91H7.928c.036.439.15.744.34.918.192.168.517.252.976.252h1.188v.91H9.197c-.334 0-.628-.023-.881-.069a1.479 1.479 0 01-.955-.604c-.339-.469-.508-1.104-.508-1.904 0-.887.238-1.577.715-2.072.164-.168.338-.285.52-.352.187-.066.437-.1.748-.1h1.596zM3.208 4.811V8.55H2.3v-5.1h1.215l1.77 3.8v-3.8h.902v5.1H5.025L3.208 4.811z",
    fill: "#fff"
  })));
}
export default SvgFont;